// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Page-canvas-container {\n  box-sizing: border-box;\n  border: 1px solid #babfc6;\n  overflow: hidden;\n}\n\n.Page-canvas-container--hidden > * {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
